import React, { forwardRef, useContext } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Grids from '@polestar/component-warehouse-react/tokens/grids/Grids';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
const spanTypes = Object.keys(DeviceTypes);
/**
 * @internal
 */
export const GridContext = React.createContext({
    span: null,
});
const Grid = forwardRef(({ nested = false, ...props }, ref) => {
    const { span, nested: contextNested } = useContext(GridContext);
    if ((contextNested || nested) && span) {
        const filledSpan = { ...span };
        let previousValue = filledSpan.mobile;
        for (const i in spanTypes) {
            const deviceType = spanTypes[i];
            if (!(deviceType in filledSpan)) {
                filledSpan[deviceType] = previousValue;
            }
            // Hidden inside a nested, so force set to 1 to keep valid css
            if (filledSpan[deviceType] === 'hidden') {
                filledSpan[deviceType] = 1;
            }
            previousValue = filledSpan[deviceType];
        }
        return React.createElement(NestedGridContainer, { ref: ref, ...props, span: filledSpan });
    }
    return React.createElement(GridContainer, { ref: ref, ...props });
});
Grid.displayName = 'Grid';
const GridContainer = styled.div `
  display: grid;
  grid-template-columns: repeat(${Grids.mobile.columns}, 1fr);
  grid-gap: ${Spacings.medium} ${Grids.mobile.gutter};
  align-items: start;

  ${MediaQueries.tablet} {
    grid-template-columns: repeat(${Grids.tablet.columns}, 1fr);
    grid-gap: ${Grids.tablet.gutter};
  }

  ${MediaQueries.desktop} {
    grid-template-columns: repeat(${Grids.desktop.columns}, 1fr);
    grid-gap: ${Grids.desktop.gutter};
  }
`;
const NestedGridContainer = styled(GridContainer)(({ span }) => css `
    grid-template-columns: repeat(${span.mobile}, 1fr);

    ${MediaQueries.tablet} {
      grid-template-columns: repeat(${span.tablet}, 1fr);
    }

    ${MediaQueries.desktop} {
      grid-template-columns: repeat(${span.desktop}, 1fr);
    }

    ${MediaQueries.desktopWide} {
      grid-template-columns: repeat(${span.desktopWide}, 1fr);
    }
  `);
export default Grid;
